<template>
  <div class="page bg-white">
    <div class="page-content">
      <div class="bar" @click="categoryExamine.show = true">
        <div class="toolbar van-hairline--bottom">
          <div class="tool-item">{{categoryName ? categoryName : '选择技能'}}<span
              class="caret"></span></div>
        </div>
      </div>
      <template v-if="noCategoryExamine">
        <div class="padding-sm text-grey">该技能暂未添加相关审核信息。</div>
      </template>
      <template v-if="showCategoryExamine">
        <van-cell-group :border="false" class="module">
          <div  v-for="(item, index) in categorySetting" :key="index">
            <div class="cellBox" v-if="item.type == 'text'">
              <van-cell-group>
                <van-field
                    v-model="item.textValue"
                    rows="2"
                    :border="false"
                    :autosize="200"
                    maxlength="200"
                    type="textarea"
                    placeholder="请输入文字内容"
                    show-word-limit
                    :label="item.title"
                />
              </van-cell-group>
            </div>
            <div v-if="item.type == 'categoryGrade'">
              <van-cell-group :border="false" class="module module-audio">
                <van-cell :border="false" title-style="color: #646566;margin-left: -15px;" class="module-title" :title="item.title">
                  <van-dropdown-menu>
                    <van-dropdown-item v-model="item.grade" :options="getGradeActions"/>
                  </van-dropdown-menu>
                </van-cell>
              </van-cell-group>
            </div>
            <div v-if="item.type == 'audio'">
              <van-cell-group :border="false" class="module module-audio">
                <van-cell :border="false" title-style="color: #646566;margin-left: -15px;" class="module-title" :title="item.title">
                  <van-popover
                      v-model="item.audioModePopover.show"
                      :actions="item.audioModePopover.actions"
                      placement="left-end"
                      theme="dark"
                      trigger="click"
                      @select="(action) => onSelectAudioMode(action, index)"
                  >
                    <template slot="reference">
                      <div class="switch-mode">{{ item.audioModePopover.selected.text }}
                        <van-icon name="arrow-down" size="14"/>
                      </div>
                    </template>
                  </van-popover>
                </van-cell>
                <van-cell>
                  <div class="uploadButton record-status">
                    <template v-if="item.audio == null">
                      <template v-if="item.audioModePopover.selected.value == 'upload'">
                        <input :ref="'input-audio' + index" type="file" @change="onSelectAudio(index)">
                        <van-icon class="icon" name="add"/>
                        <div class="text">上传录音文件</div>
                      </template>
                      <template v-else-if="item.audioModePopover.selected.value == 'record'">
                        <template v-if="!item.record.isRecording">
                          <i class="icon iconfont icon-record" @click="handleRecordStart(index)"></i>
                          <div class="text">点击开始录音</div>
                        </template>
                        <template v-else>
                          <i class="icon iconfont icon-record recording" @click="handleRecordStop(index)"></i>
                          <div class="text">点击停止录音<br>{{ item.record.countdown }}秒后自动停止</div>
                        </template>
                      </template>
                    </template>
                    <template v-else>
                      <template v-if="item.player.status == 0">
                        <div>
                          <van-icon class="icon" color="var(--primary-color)" name="play-circle" @click="playAudio(index)"/>
                          <div class="text">播放录音</div>
                        </div>
                      </template>
                      <template v-if="item.player.status == 1">
                        <van-icon class="icon" color="var(--primary-color)" name="pause-circle" @click="stopAudio(index)"/>
                        <div class="text">停止播放</div>
                      </template>
                    </template>
                  </div>
                </van-cell>
                <van-cell v-if="item.audio != null" >
                  <div class="text-center">
                    <div class="btn-rerecording" @click="onRerecord(index)">
                      <van-icon name="replay" size="14"/>
                      {{ item.audioModePopover.selected.value == 'upload' ? '重新上传' : '重录' }}
                    </div>
                  </div>
                </van-cell>
              </van-cell-group>
            </div>

            <div v-if="item.type == 'picture'">
              <UploadImg class="module" @uploadimg="(value) => uploadimg(value, index)" :imgArr="item.photoUrls" :imgAmount="item.imgAmount" :title="item.title"></UploadImg>
            </div>
            <div v-if="item.type == 'video'">
              <van-cell-group :border="false" class="module module-audio">
                <van-cell :border="false" title-style="color: #646566;margin-left: -15px;" :title="item.title">
                </van-cell>
                <van-cell v-if="item.video.length == 0">
                  <div class="uploadButton record-status text-center">
                    <van-uploader v-model="item.video" :max-count="1"
                                  :max-size="15 * 1024 * 1024" accept="video/*" @oversize="onOversize()" :after-read="(file) => videoRead(file, index)">
                      <van-icon class="icon" name="add"/>
                      <div class="text">上传视频文件</div>
                    </van-uploader>
                  </div>
                </van-cell>
                <van-cell v-else>
                  <div class="text-center">
                    <div>
                      <video :src="item.localVideo"
                             controls="true" style="width: 80%;height: 200px"></video>
                    </div>
                    <div class="btn-rerecording" @click="resetVideo(index)">
                      <van-icon name="replay" size="14"/>
                      重新上传
                    </div>
                  </div>
                </van-cell>
              </van-cell-group>
            </div>
          </div>
          <div>
            <van-button round type="primary" style="width: 100%" @click="handleConfirm">提交</van-button>
          </div>
        </van-cell-group>
      </template>
    </div>
    <van-action-sheet
        v-model="categoryExamine.show"
        :actions="categoryExamine.actions"
        cancel-text="取消"
        @select="onCategoryExamine"/>
  </div>
</template>

<script>
import Vue from "vue";
import {
  ActionSheet,
  Button,
  CellGroup,
  Cell,
  Field,
  Radio,
  Checkbox,
  Icon,
  Popover,
  Uploader,
  Dialog,
  Toast,
  ImagePreview, DropdownMenu, DropdownItem
} from "vant";
import { getCategoryList, getCategoryExamine, applyCategoryExamine, getDefaultCategory } from '@/api/clerk/category'
import {audioToMp3, wxAudioMediaIdToMp3} from "@/api/file"
import {wx, wxConfig} from "@/libs/jssdk-util";
import UploadImg from "@/views/clerk/UploadImg";


Vue.use(Button)
    .use(ActionSheet)
    .use(CellGroup)
    .use(Cell)
    .use(Field)
    .use(Radio)
    .use(Checkbox)
    .use(Icon)
    .use(Popover)
    .use(Uploader)
    .use(Dialog)
    .use(Toast)
    .use(DropdownMenu)
    .use(DropdownItem)
    .use(ImagePreview);

export default {
  name: "category-examine-apply",
  components: {
    UploadImg
  },
  data() {
    return {
      categoryExamine: {
        show: false,
        actions: []
      },
      categoryId: null,
      categoryExamineId: null,
      categoryName: '',
      noCategoryExamine: false,
      showCategoryExamine: false,
      categorySetting: [],
      isDefault: false,
      defaultSetting: []
    };
  },
  computed: {
    getGradeActions(){
      let arr = []
      arr.push({text: '选择等级', value: 0})
      let clerkGradeMap = this.$store.state.ClerkGradeMap
      for(let key in clerkGradeMap) {
        arr.push({text: clerkGradeMap[key], value: key})
      }
      return arr
    }
  },
  watch: {
  },
  methods: {
    resetVideo(index) {
      let item = this.categorySetting[index];
      item.video = [];
      item.localVideo = null;
    },
    // 开始录音
    handleRecordStart(index) {
      let that = this
      let item = this.categorySetting[index];
      wx.startRecord({
        success: function () {
          clearInterval(item.record.countdownTimer)
          item.record.isRecording = true
          // 倒计时结束自动停止录音
          item.record.countdown = item.record._countdown
          item.record.countdownTimer = setInterval(() => {
            item.record.countdown--
            if (item.record.countdown <= 0) {
              clearInterval(item.record.countdownTimer)
              that.handleRecordStop(index)
            }
          }, 1000)
        },
        fail(err) {
          item.record.isRecording = false
          Dialog.alert({
            title: '开始录音失败',
            message: err.errMsg
          })
        }
      })
    },
    // 停止录音
    handleRecordStop(index) {
      let that = this
      let item = that.categorySetting[index];
      if (item.record.isRecording) {
        item.record.isRecording = false
        Toast.loading({
          mask: true,
          duration: 0,
          message: '音频上传中'
        })
        wx.stopRecord({
          success: function (res) {
            wx.uploadVoice({
              localId: res.localId,
              isShowProgressTips: 1, // 默认为1，显示进度提示
              success(res) {
                const mediaId = res.serverId

                wxAudioMediaIdToMp3(mediaId).then(res => {
                  Toast.clear()
                  const data = res.data;
                  if (data.code == 0) {
                    that.$set(that.categorySetting[index], 'audio', 'data:audio/mpeg;base64,' + data.audio)
                    that.$set(that.categorySetting[index].player, 'status', 0)
                  } else {
                    Dialog.alert({
                      title: '上传音频失败',
                      message: data.msg
                    })
                  }
                })
              },
              fail(err) {
                Toast.clear()
                Dialog.alert({
                  title: '上传录音失败',
                  message: err.errMsg
                })
              }
            })
          },
          fail(err) {
            Toast.clear()
            Dialog.alert({
              title: '停止录音失败',
              message: err.errMsg
            })
          }
        })
      }
    },
    onSelectAudioMode(action, index) {
      let item = this.categorySetting[index];
      if (item.audioModePopover.selected.value != action.value) {
        item.audioModePopover.selected = action
        item.record.isRecording = false
        item.audio = null
        if (item.player.audio != null) {
          item.player.audio.pause()
        }
      }
    },
    onOversize() {
      Toast('视频大小不能超过15M');
    },
    videoRead(file, index) {
      let that = this
      if ((file.file.type).indexOf('video/') == -1) {
        that.$set(that.categorySetting[index], 'video', [])
        return Toast('仅支持请上传视频')
      }
      let reader = new FileReader();
      reader.readAsDataURL(file.file);
      reader.onload = function (e) {
        that.$set(that.categorySetting[index], 'localVideo', e.currentTarget.result)
      }
    },
    uploadimg(imgarr, index){
      let item = this.categorySetting[index];
      item.photoUrls = imgarr
    },
    onCategoryExamine(item) {
      if (this.isDefault) {
        this.setDefault(item)
      } else {
        if (this.categoryName == '') {
          this.showCategory(item)
        } else if (this.categoryName != item.name) {
          if (this.categorySetting.length > 0) {
            Dialog.confirm({title: '提示',message: '确定要选择其他技能吗？\n该操作会清空当前已填数据'}).then(()=>{
              // 这里是点击确定
              this.showCategory(item)
            }).catch(() => {
              // 这里走到取消
              this.categoryExamine.show = false
            })
          } else {
            this.showCategory(item)
          }
        }
      }
    },
    showCategory(item) {
      this.categoryName = item.name
      this.noCategoryExamine = item.value == undefined;
      if (item.value) {
        this.showCategoryExamine = true
        this.categoryExamineId = item.value
        getCategoryExamine(item.value).then(res => {
          let data = res.data
          if (data.code == 0) {
            this.categorySetting = data.examine.setting
            this.categoryId = data.examine.categoryId
          } else {
            Dialog.alert({
              title: '加载技能申请信息失败',
              message: data.msg
            })
          }
        })
      } else {
        this.showCategoryExamine = false
        this.categorySetting = []
      }
      this.categoryExamine.show = false
    },
    setDefault(item){
      this.noCategoryExamine = false
      this.showCategoryExamine = true
      this.categoryExamineId = null
      this.categoryId = item.id
      this.categorySetting = this.defaultSetting
      this.categoryName = item.name
      this.categoryExamine.show = false
    },
    loadData() {
      // 获取默认审核信息
      getDefaultCategory().then(res => {
        const data = res.data
        if (data.code == 0) {
          this.isDefault = data.isDefault != null ? data.isDefault : false
          this.defaultSetting = data.setting != null ? data.setting : []
          if (this.categoryName && this.isDefault) {
            this.categorySetting = this.defaultSetting
          }
        }
      })

      // 获取申请状态
      Toast.loading({
        mask: true,
        duration: 0
      })
      // 获取分类列表
      getCategoryList().then(res => {
        const data = res.data
        if (data.code == 0) {
          Toast.clear()
          this.categoryExamine.actions = data.examineList
        } else {
          Dialog.alert({
            title: '加载技能失败',
            message: data.msg
          })
        }
      })
    },
    onRerecord(index) {
      let item = this.categorySetting[index];
      this.$set(this.categorySetting[index], 'audio', null)
      this.$set(this.categorySetting[index].player, 'status', 0)
      if (item.player.audio != null) {
        item.player.audio.pause()
      }
    },
    onSelectAudio(index) {
      const that = this
      let key = 'input-audio' + index
      const files = this.$refs[key][0].files
      if (files.length > 0) {
        const file = files[0]
        if (['audio/x-mpeg', 'audio/mpeg', 'audio/mp3', 'audio/x-m4a', 'audio/mp4a-latm', 'audio/vnd.dlna.adts', 'audio/aac'].indexOf(file.type) == -1) {
          if (file.name != null && file.name.lastIndexOf('.') != -1) {
            let ext = file.name.substr(file.name.lastIndexOf('.') + 1).toLowerCase()
            if (['mp3', 'm4a', 'amr'].indexOf(ext) == -1) {
              return Toast('仅支持请上传m4a或mp3格式')
            }
          } else {
            return Toast('仅支持请上传m4a或mp3格式')
          }
        }
        if (file.size > 2 * 1024 * 1024) {
          return Toast('音频大小不能超过2M')
        }

        Toast.loading({
          mask: true,
          duration: 0,
          message: '音频上传中'
        })
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function (e) {
          audioToMp3(e.target.result).then(res => {
            Toast.clear()
            const data = res.data;
            if (data.code == 0) {
              const base64 = 'data:audio/mpeg;base64,' + data.audio
              that.$set(that.categorySetting[index], 'audio', base64)
              that.$set(that.categorySetting[index].player, 'status', 0)
            } else {
              Dialog.alert({
                title: '上传音频失败',
                message: data.msg
              })
            }
          })
        }
      }
    },
    // 播放录音
    playAudio(index) {
      let item = this.categorySetting[index];
      item.player.audio = new Audio(item.audio)
      item.player.audio.play()
      item.player.status = 1
      // 播放结束事件
      item.player.audio.onended = () => {
        item.player.status = 0
      }
    },
    // 停止播放录音
    stopAudio(index) {
      let item = this.categorySetting[index];
      item.player.audio.pause()
      item.player.status = 0
    },
    // 提交表单
    handleConfirm() {
      let that = this
      let result = []
      let grade = 0;
      for (let i = 0; i < this.categorySetting.length; i++) {
        let item = this.categorySetting[i];
        let type = item.type
        if (type == 'text' && (!item.textValue || item.textValue == null)) {
          return Toast("请输入第" + (i + 1) + '行的' + item.title);
        } else if (type == 'picture' && (!item.photoUrls || item.photoUrls == null || item.photoUrls.length < 1)) {
          return Toast("请上传第" + (i + 1) + '行的' + item.title);
        } else if (type == 'audio' && (!item.audio || item.audio == null)) {
          return Toast("请上传第" + (i + 1) + '行的' + item.title);
        } else if (type == 'video' && (!item.localVideo || item.localVideo == null)) {
          return Toast("请上传第" + (i + 1) + '行的' + item.title);
        } else if (type == 'categoryGrade' && (item.grade == 0)) {
          return Toast("请选择第" + (i + 1) + '行的' + item.title);
        } else if (type == 'text') {
          result.push({
            title: item.title,
            type: item.type,
            textValue: item.textValue
          })
        } else if (type == 'picture') {
          result.push({
            title: item.title,
            type: item.type,
            photoUrls: item.photoUrls
          })
        } else if (type == 'audio') {
          result.push({
            title: item.title,
            type: item.type,
            audio: item.audio
          })
        } else if (type == 'video') {
          result.push({
            title: item.title,
            type: item.type,
            video: item.video[0]
          })
        } else if (type == 'categoryGrade') {
          grade = item.grade
          result.push({
            title: item.title,
            type: item.type,
            grade: item.grade
          })
        }
      }
      // 提交
      Toast.loading({
        mask: true,
        message: '请稍候...',
        duration: 0
      })
      applyCategoryExamine(this.categoryExamineId, this.categoryId, grade, JSON.stringify(result)).then(res => {
        Toast.clear()
        const data = res.data;
        if (data.code == 0) {
          Dialog.alert({
            title: '申请成功'
          }).then(()=>{
            that.noCategoryExamine = false
            that.showCategoryExamine = false
            that.categoryExamineId = null
            that.categoryId = null
            that.categoryName = ''
            that.categoryExamine.show = false
            this.categorySetting = []
            this.$router.back(-1)
          })
        } else {
          Dialog.alert({
            title: '申请失败',
            message: data.msg
          })
        }
      })
    }
  },
  activated() {
    this.loadData();
    wxConfig(['startRecord', 'stopRecord', 'playVoice', 'stopVoice', 'onVoicePlayEnd', 'uploadVoice', 'chooseImage', 'previewImage', 'getLocalImgData'])
    wx.error(function (err) {
      Dialog.alert({
        title: '微信配置失败，请刷新页面',
        message: JSON.stringify(err)
      })
    });
  },
  beforeRouteLeave(to, form, next) {
    for (let i = 0; i < this.categorySetting.length; i++) {
      let item = this.categorySetting[i];
      if (item.type == 'audio' && item.player.audio != null) {
        item.player.audio.pause()
      }
    }
    this.categoryId = null
    this.categoryName = ''
    this.noCategoryExamine = false
    this.showCategoryExamine = false
    this.categorySetting = []
    this.categoryExamine.show = false
    next()
  }
};
</script>
<style lang="less" scoped>
.cellBox{
  margin: 10px 0;
}
.bar {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  height: 40px;
  line-height: 40px;
  padding: 8px 0;
  background: #fff;
}
.page {
  width: 100%;
  min-height: 100%;
  box-sizing: border-box;
  position: absolute;
  top: 0;
  left: 0;
  background: #f5f5f5;

  .page-content {
    padding-bottom: 100px;
  }

  .module {
    margin-top: 15px;
    padding: 0px 15px;
    position: relative;
    /deep/ .van-cell {
      .van-cell__title {
        font-weight: bold;
      }
    }
  }

  .image-uploader {
    /deep/ .van-uploader__wrapper {
      .van-uploader__preview {
        .van-uploader__preview-delete {
          top: 0;
          right: 0;
          color: var(--primary-color);
        }
      }
    }
  }

  .module-audio {

    .switch-mode {
      display: inline-flex;
      align-items: center;
      color: #333;
      font-size: 14px;
      height: 20px;
      line-height: 20px;

      .van-icon {
        margin-right: 3px;
      }
    }

    .record-status {
      position: relative;

      .icon {
        display: block;
        width: 80px;
        height: 80px;
        color: var(--primary-color);
        font-size: 60px;
        border-radius: 50%;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .text {
        color: #999;
        font-size: 16px;
        text-align: center;
      }

      input {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        overflow: hidden;
        cursor: pointer;
        opacity: 0;
        z-index: 3;
      }

      .btn-rerecording {
        display: flex;
        align-items: center;
        color: #333;
        font-size: 14px;
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);

        .van-icon {
          margin-right: 3px;
        }
      }
    }
  }
}

.title {
  padding-bottom: 15px;
}
  /deep/.van-dialog__message--has-title {
    color: red !important;
  }

  .UploadImg{
    background: #fff;
    padding: 15px 15px !important;

    .felxBox{
      display: flex;
      margin: 10px 0
    }


    .chooseImage{
      width: 70px;
      height: 70px;
      background: #ececec;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }



</style>
